module.exports = __webpack_public_path__ + "pc/img/rec_16.b659f0e2.svg";